import StatusIcon from './StatusIcon'

interface StatusRowProps {
  label: string
  value?: boolean | null
}

export default function StatusRow({ label, value }: StatusRowProps) {
  return (
    <div className="flex items-center justify-between py-2 border-b border-gray-200 last:border-0">
      <span className="text-sm text-[#3C2416]">{label}</span>
      <StatusIcon value={value} />
    </div>
  )
}
